import {TriggerUpdateTableDataType} from '../actions/actionTypes';

const defaultState = Date.now();

const triggerUpdateTableDataReducer = (state = defaultState, action) => {
  switch (action.type) {
    case TriggerUpdateTableDataType.TRIGGER:
      return action.data;

    default:
      return state;
  }
};

export default triggerUpdateTableDataReducer;
